// import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './pages/index';
import Register from './pages/register';
import Login from './pages/login';
import WelcomePage from './pages/dashboard/index';
import ContactsInfo from './pages/dashboard/contactinfo';
import UsersInfo from './pages/dashboard/userinfo';
import AccountSettings from './pages/dashboard/accountsettings';

function Routers () {
    return (
      <Router>
        <Routes>
           <Route path="/" exact element={<Home/>}/>
           <Route path="/register" exact element={<Register/>}/>
           <Route path="/login" exact element={<Login/>}/>
           {/* ////////
           // Dashboard
           ///// */}
           <Route path="/dashboard" exact element={<WelcomePage/>}/>
            <Route path="/dashboard/contacts-info" exact element={<ContactsInfo/>}/>
             <Route path="/dashboard/users-info" exact element={<UsersInfo/>}/>
              <Route path="/dashboard/account-settings" exact element={<AccountSettings/>}/>
      </Routes>
  </Router>
    )
}
  

export default Routers;